import React from "react";
import { Box, Typography, Button, Container, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useThemeColors } from "../../hooks/useThemeColors";
import { meses, anos } from "../../data/mockData";

// Componente de Logo
const Logo = () => (
  <Box
    component="img"
    src="/logobranca.png"
    alt="Logo Prime Class"
    sx={{
      height: 60,
      width: "auto",
      mr: 2,
    }}
    onError={(e) => {
      // Fallback caso a imagem não exista
      e.target.style.display = "none";
    }}
  />
);

function Header({
  showFiltros = false,
  onToggleFiltros,
  mesSelecionado,
  setMesSelecionado,
  anoSelecionado,
  setAnoSelecionado,
  filtroVGV,
  setFiltroVGV,
  filtroAtivo,
  setFiltroAtivo,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const colors = useThemeColors();
  const isDashboard = location.pathname === "/dashboard";
  const isHome = location.pathname === "/";
  const isAdmin = location.pathname === "/login" || location.pathname === "/configuracao";

  const opcoesVGV = [
    'Todos',
    '50000',
    '100000',
    '150000',
    '200000',
    '250000',
    '300000',
  ];

  const opcoesAtivo = ['Todos', 'Sim', 'Não'];

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${colors.border.primary}`,
        py: 1.5,
        mb: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Logo />
          <Box>
           
          
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          {/* Botão Filtrar Pesquisa - apenas no Dashboard */}
          {isDashboard && (
            <Button
              variant={showFiltros ? "contained" : "outlined"}
              onClick={onToggleFiltros}
              sx={{
                backgroundColor: showFiltros ? "#ffffff" : "transparent",
                color: showFiltros ? "#000000" : "primary.main",
                border: `1px solid ${colors.border.primary}`,
                px: 3,
                py: 1,
                fontWeight: "bold",
                textTransform: "Capitalize",
                "&:hover": {
                  backgroundColor: showFiltros ? "#f5f5f5" : colors.hover.light,
                },
              }}
            >
              {showFiltros ? "Fechar" : "Filtrar Pesquisa"}
            </Button>
          )}
          
          {/* Filtros - aparecem quando showFiltros é true */}
          {isDashboard && showFiltros && (
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>Mês</InputLabel>
                <Select
                  value={mesSelecionado}
                  label="Mês"
                  onChange={(e) => setMesSelecionado(e.target.value)}
                  sx={{
                    color: 'text.primary',
                    fontSize: '0.875rem',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.hover,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <MenuItem value="Todos">Todos</MenuItem>
                  {meses.map((mes) => (
                    <MenuItem key={mes} value={mes}>
                      {mes}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>Ano</InputLabel>
                <Select
                  value={anoSelecionado}
                  label="Ano"
                  onChange={(e) => setAnoSelecionado(e.target.value)}
                  sx={{
                    color: 'text.primary',
                    fontSize: '0.875rem',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.hover,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <MenuItem value="Todos">Todos</MenuItem>
                  {anos.map((ano) => (
                    <MenuItem key={ano} value={ano}>
                      {ano}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>VGV</InputLabel>
                <Select
                  value={filtroVGV}
                  label="VGV"
                  onChange={(e) => setFiltroVGV(e.target.value)}
                  sx={{
                    color: 'text.primary',
                    fontSize: '0.875rem',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.hover,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  {opcoesVGV.map((opcao) => (
                    <MenuItem key={opcao} value={opcao}>
                      {opcao === 'Todos'
                        ? 'Todos'
                        : `R$ ${parseFloat(opcao).toLocaleString('pt-BR')}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>Ativos</InputLabel>
                <Select
                  value={filtroAtivo}
                  label="Ativos"
                  onChange={(e) => setFiltroAtivo(e.target.value)}
                  sx={{
                    color: 'text.primary',
                    fontSize: '0.875rem',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: colors.border.hover,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  {opcoesAtivo.map((opcao) => (
                    <MenuItem key={opcao} value={opcao}>
                      {opcao}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}

          <Button
            variant={isHome ? "contained" : "outlined"}
            onClick={() => navigate("/")}
            sx={{
              backgroundColor: isHome ? "primary.main" : "transparent",
              color: isHome ? "#000" : "primary.main",
              border: `1px solid ${colors.border.primary}`,
              px: 3,
              py: 1,
              fontWeight: "bold",
              textTransform: "Capitalize",
              "&:hover": {
                backgroundColor: isHome
                  ? "primary.dark"
                  : colors.hover.light,
              },
            }}
          >
            Painel do Adm
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
